import { initI18N } from '../utils/common-i18n';

import './shared/helpers/loggerConfig';

import ReactDOM from 'react-dom';

import { initStore } from '../init-store';
import { getRootElement } from './index.common';
import {
    isMessengerIntegration,
    selectIsDebugToolsEnabled,
    selectIsMeetingRoomIntegration,
    selectIsPdokHeaderEnabled,
    selectIsTeleMessenger,
} from './shared/features/config/selectors';
import { fedyaModuleFederation as moduleFederation } from './shared/features/module-federation/module-federation';
import { initBrowser } from './shared/helpers/browser-capabilities';
import { getPreloadedState } from './shared/helpers/get-preloaded-state';
import { initHostApi } from './shared/helpers/host-api';
import { init } from './shared/helpers/metrika';
import { initHistoryListener } from './shared/helpers/navigation';
import isOnPremise from './shared/helpers/onpremise/is-onpremise';
import { initVirtualKeyboardController } from './shared/helpers/virtual-keyboard-controller';
import { bugFormController } from './shared/helpers/yndx-bug';

if (!isOnPremise) {
    require('@yandex-int/rum-counter/dist/bundle/implementation');
    require('@yandex-int/rum-counter/dist/bundle/onload');
}

async function initAll() {
    initI18N();

    const preloadedState = getPreloadedState();

    if (preloadedState.ua) {
        initBrowser(preloadedState.ua);
    }

    initHistoryListener();

    // Использует информацию о браузере, поэтому должно инициализироваться после initBrowser
    initVirtualKeyboardController();

    // Инициализируем метрику до стора, потому что в инициализации уже используются саги с метриками
    if (!isOnPremise) {
        init({
            uid: preloadedState?.user?.uid,
            metrikaCounterId: 63085042,
            prefix: 'web',
            experiments: preloadedState?.config?.experiments && preloadedState?.config?.experiments.metrika,
        });
    }

    const store = initStore(preloadedState);

    const state = store.getState();

    if (selectIsDebugToolsEnabled(state)) {
        // @ts-expect-error
        window.__store = store;
    }

    (['log', 'info', 'warn', 'error', 'debug'] as const).forEach((method) => {
        if (state.config.hideLogs) {
            // eslint-disable-next-line no-console
            console[method] = () => {};
            return;
        }

        const pad = (n: number, c = 2) => n.toString().padStart(c, '0');

        const getTime = () => {
            const d = new Date();

            return (
                '[' +
                d.getFullYear() +
                '-' +
                pad(d.getMonth() + 1) +
                '-' +
                pad(d.getDate()) +
                ' ' +
                pad(d.getHours()) +
                ':' +
                pad(d.getMinutes()) +
                ':' +
                pad(d.getSeconds()) +
                '.' +
                pad(d.getMilliseconds(), 3) +
                ']'
            );
        };

        // eslint-disable-next-line no-console
        const origMethod = console[method].bind(console);
        // eslint-disable-next-line no-console
        console[method] = (...args: never[]) => origMethod(getTime(), ...args);
    });

    if (!NODE) {
        initHostApi(store);

        if (!isOnPremise) {
            bugFormController.init();
        }
    }
    if (
        selectIsPdokHeaderEnabled(state) &&
        !isMessengerIntegration(state) &&
        !selectIsMeetingRoomIntegration(state) &&
        !selectIsTeleMessenger(state)
    ) {
        await moduleFederation?.initMfComponents();
    }
    // todo: переход на hydrateRoot вызывает ошибки гидрации
    // Разобраться в рамках https://st.yandex-team.ru/TELEMOSTFRONT-4266
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.hydrate(getRootElement(store), document.getElementById('root'));
}

initAll();
